import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const ExternalLinkBlue = () => (
  <ImageIcon src={Images.ExternalLinkBlue} alt="external-link-blue" />
);

export default ExternalLinkBlue;
